import React, {useCallback, useContext} from "react"
import {Dialog, DialogContent, Grid, IconButton, styled, Typography,} from "@mui/material"
import {DataContext} from "../../../src/context/DataContextProvider"
import Content from "../Content"
import {Close} from "@mui/icons-material"
import {ActionContext} from "../../../src/context/ActionContextProvider"

export const ROOT_DIALOG_POINTER = "/appstate/activeRootDialogIdentifier"

export const containerRootDialogPrototype = [
    {
        key: "identifier",
        type: "STRING",
        label: "Identifier",
        size: 6,
    },
    {
        key: "fullwidth",
        type: "YESNO",
        label: "Fullwidth",
        size: 3,
    },
    {
        key: "ignoreOutsideClick",
        type: "YESNO",
        label: "Outside klick verhindern",
        size: 3,
    },
    {
        key: "action",
        type: "STRING",
        label: "On close Action",
        size: 3,
    },
    {
        key: "subtitle",
        type: "STRING",
        label: "Subtitle",
        size: 3,
    },
    {
        key: "maxWidth",
        type: "SELECT",
        label: "Breakpoint",
        size: 3,
        options: [
            {
                value: "xs",
                label: "xs",
            },
            {
                value: "sm",
                label: "sm",
            },
            {
                value: "md",
                label: "md",
            },
            {
                value: "lg",
                label: "lg",
            },
            {
                value: "xl",
                label: "xl",
            },
            {
                value: "false",
                label: "false",
            },
        ],
    },
]

const StyledResponsiveDialog = styled(Dialog)(({theme}) => ({
    "& .MuiPaper-root": {
        padding: "24px",
        gap: '16px'
    },
}))

const StyledResponsiveDialogContent = styled(DialogContent)(({theme}) => ({
    padding: 0,
}))

const StyledDialogTitle = styled(Typography)(({theme}) => theme.ROOT_DIALOG.title)
const StyledDialogSubtitle = styled(Typography)(({theme}) => theme.ROOT_DIALOG.subtitle)

const RootDialog = ({container = {}}) => {
    const {maxWidth = "md", fullwidth = true, action, ignoreOutsideClick, children, text, subtitle} = container
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const {triggerAction} = useContext(ActionContext)
    const activeContainer = getDataFromPointer(ROOT_DIALOG_POINTER)
    const isOpen = activeContainer === container?.identifier

    const onClose = useCallback(() => {
        action ? triggerAction(action) : updateData("", ROOT_DIALOG_POINTER)
    }, [action, triggerAction])

    return (
        <StyledResponsiveDialog
            open={isOpen}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullwidth}
            aria-labelledby={text}>
            <Grid container sx={{display: "flex", flexDirection: "column"}}>
                <Grid sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <StyledDialogTitle>
                        {text}
                    </StyledDialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        size="small">
                        <Close color="#000" />
                    </IconButton>
                </Grid>
                <Grid>
                    <StyledDialogSubtitle>
                        {subtitle}
                    </StyledDialogSubtitle>
                </Grid>
            </Grid>
            <StyledResponsiveDialogContent>
                {children?.map((child) => <Content key={child?.id} child={child}/>)}
            </StyledResponsiveDialogContent>
        </StyledResponsiveDialog>
    )
}

export default RootDialog
